import * as React from "react";
import type { SVGProps } from "react";
const SvgEmptyBox = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={78}
    height={98}
    fill="none"
    viewBox="0 0 78 98" {...props}
  >
    <path
      fill="#fff"
      stroke="#00217B"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={0.891}
      d="m76.767 61.327-6.004 23.357c-.612 2.428-2.235 4.394-4.38 5.316l-14.885 6.423a6.88 6.88 0 0 1-5.513 0l-.888-.368-40.98-17.64c-2.42-1.046-3.676-3.965-2.88-6.67l6.586-22.588a10.3 10.3 0 0 1 1.378-2.92c.95-1.352 2.236-2.427 3.706-3.073l12.864-5.593c2.205-.953 4.655-1.014 6.891-.123l40.246 15.704a6.3 6.3 0 0 1 3.185 2.858c.092.185.184.339.275.523a7.4 7.4 0 0 1 .399 4.825z"
    />
    <path
      fill="#00217B"
      d="m76.307 57.974-21.715 6.854L9.17 46.204c.95-1.352 2.236-2.428 3.706-3.073L27.456 36c2.204-.953 4.655-1.014 6.89-.123l38.53 17.24c1.38.554 2.451 1.845 3.155 3.135.092.185.184 1.568.246 1.752z"
    />
    <path
      stroke="#00217B"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={0.965}
      d="m27.945 43.32 29.342 12.355"
    />
    <path
      fill="url(#empty-box_svg__a)"
      d="m76.767 61.328-6.003 23.356c-.613 2.428-2.236 4.395-4.38 5.317l-14.059 5.993c-1.776.768-3.614 1.321-5.39.553l-.919-.553 8.27-31.286 21.807-8.727c.092.184.184.337.276.522a7.4 7.4 0 0 1 .398 4.825"
      opacity={0.6}
      style={{
        mixBlendMode: "multiply",
      }}
    />
    <path
      stroke="#fff"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={0.668}
      d="m25.28 40.738 36.05 16.073"
    />
    <path
      stroke="#00217B"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={0.26}
      d="m67.64 57.395-3.247 13.553 1.9 3.718-1.808 7.745-2.726 1.844-2.94 9.28"
    />
    <path
      fill="#fff"
      stroke="#00217B"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={0.891}
      d="M27.67 40.86 38.051 14a1.695 1.695 0 0 1 2.206-.983l7.044 2.736a2.52 2.52 0 0 1 1.562 1.813l.766 3.104 18.438 6.945a1.797 1.797 0 0 1 1.041 2.336l-9.617 25.047L27.67 40.892z"
    />
    <path
      stroke="#00217B"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={0.742}
      d="m30.732 5.734 3.033 3.688M44.699 8.101l2.328-3.042M39.124 7.423 38.971 1"
    />
    <path
      fill="#00D9CA"
      d="M44.485 92.888a23.5 23.5 0 0 0-3.553-9.189c-1.225-1.874-2.757-3.657-4.502-5.009.337-1.014.52-2.06.49-3.135-.092-3.257-1.746-6.238-3.92-8.297-5.269-5.01-12.436-4.457-18.837-5.747-3.032-.615-6.218-1.63-8.576-3.965-.245-.246-.46-.492-.704-.737l-.43 1.782c1.318 1.322 2.88 2.336 4.534 3.073 6.003 2.674 12.741 1.63 18.775 4.118 2.48 1.015 4.809 2.766 6.279 5.256 1.194 2.028 1.715 4.487 1.072 6.76-.46-.276-.889-.522-1.379-.737-1.5-.676-3.154-.83-4.655-.092-1.287.615-2.42 1.905-2.634 3.504-.123.921 0 1.905.551 2.642.49.677 1.256.984 1.991 1.107 1.378.246 2.757-.062 3.951-.86 1.133-.738 2.113-1.845 2.787-3.166 1.042.83 1.96 1.782 2.818 2.858 1.838 2.274 3.216 5.04 4.012 8.021.184.738.337 1.475.46 2.244.061.43.275 3.042.122 3.134-.367.215 1.379-3.134 1.287-3.595zM29.2 82.624c-.582-.123-1.133-.37-1.286-1.076-.122-.615.061-1.26.368-1.782.673-1.138 1.93-1.66 3.093-1.599 1.103.062 2.175.523 3.124 1.168-1.072 2.06-3.124 3.78-5.33 3.289z"
      opacity={0.3}
    />
    <path
      fill="url(#empty-box_svg__b)"
      d="M57.578 41.485c.408-.35.372-1.063-.08-1.592-.451-.53-1.148-.674-1.555-.324s-.372 1.063.08 1.592c.451.53 1.148.674 1.555.324"
    />
    <path
      fill="url(#empty-box_svg__c)"
      d="M56.212 44.684c.407-.35.371-1.063-.08-1.592-.452-.529-1.148-.674-1.556-.324-.407.35-.371 1.063.08 1.592.452.53 1.148.674 1.556.324"
    />
    <path
      fill="url(#empty-box_svg__d)"
      d="M54.845 48.34c.408-.35.372-1.063-.08-1.592-.451-.529-1.148-.674-1.555-.323-.408.35-.372 1.063.08 1.592s1.148.674 1.555.323"
    />
    <path
      fill="url(#empty-box_svg__e)"
      d="m51.06 46.774.971-1.469-13.444-5.645-.89 1.408z"
    />
    <path
      fill="url(#empty-box_svg__f)"
      d="m52.768 43.575.972-1.47-13.445-5.644-.89 1.407z"
    />
    <path
      fill="url(#empty-box_svg__g)"
      d="m54.248 40.371.972-1.468-13.444-5.645-.891 1.407z"
    />
    <path
      fill="#00217B"
      d="M52.127 28.487c.076-.453-.016-.886-.274-1.326-.257-.439-.664-.805-1.196-1.07-.533-.264-.695-.295-1.012-.318s-.578.025-.797.154c-.218.13-.356.332-.437.605s-.065.351-.035.534c.031.183.101.358.208.55.095.176.24.36.4.531.146.183.356.36.552.55l.746.647c.255.233.488.439.692.667.205.228.37.465.51.698.14.234.23.462.266.71.05.236.036.478-.032.74-.103.36-.3.632-.575.806-.289.186-.628.25-1.035.23-.417-.034-.874-.175-1.382-.437a4.4 4.4 0 0 1-1.18-.875c-.308-.33-.538-.676-.66-1.061a2.1 2.1 0 0 1-.096-1.1l.471.244q-.088.452.092.895c.12.296.294.572.558.845.252.259.572.487.933.681s.768.33 1.11.355c.343.026.629-.019.861-.16.233-.14.385-.354.47-.652a1.13 1.13 0 0 0-.012-.706c-.075-.24-.215-.473-.417-.726-.202-.254-.48-.515-.793-.794l-.804-.693c-.536-.47-.92-.923-1.138-1.37-.233-.437-.285-.879-.162-1.3.124-.423.287-.623.573-.783.275-.174.614-.238 1.007-.207a3.25 3.25 0 0 1 1.247.383c.434.228.799.513 1.107.842.294.34.499.684.622 1.07.123.385.134.745.07 1.097l-.446-.242zm-3.754 4.924 2.386-8.577.35.18-2.386 8.577z"
    />
    <defs>
      <linearGradient
        id="empty-box_svg__a"
        x1={47.057}
        x2={77.437}
        y1={116.031}
        y2={35.489}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#00DACB" />
        <stop offset={1} stopColor="#258AE9" />
      </linearGradient>
      <linearGradient
        id="empty-box_svg__b"
        x1={70.206}
        x2={21.703}
        y1={39.709}
        y2={42.669}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#98CBFF" />
        <stop offset={1} stopColor="#98CBFF" stopOpacity={0} />
      </linearGradient>
      <linearGradient
        id="empty-box_svg__c"
        x1={69.563}
        x2={21.07}
        y1={42.852}
        y2={45.803}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#98CBFF" />
        <stop offset={1} stopColor="#98CBFF" stopOpacity={0} />
      </linearGradient>
      <linearGradient
        id="empty-box_svg__d"
        x1={68.197}
        x2={19.704}
        y1={46.509}
        y2={49.46}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#98CBFF" />
        <stop offset={1} stopColor="#98CBFF" stopOpacity={0} />
      </linearGradient>
      <linearGradient
        id="empty-box_svg__e"
        x1={22.256}
        x2={70.566}
        y1={45.916}
        y2={40.761}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#98CBFF" />
        <stop offset={1} stopColor="#98CBFF" stopOpacity={0} />
      </linearGradient>
      <linearGradient
        id="empty-box_svg__f"
        x1={23.965}
        x2={72.275}
        y1={42.716}
        y2={37.562}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#98CBFF" />
        <stop offset={1} stopColor="#98CBFF" stopOpacity={0} />
      </linearGradient>
      <linearGradient
        id="empty-box_svg__g"
        x1={25.445}
        x2={73.755}
        y1={39.513}
        y2={34.358}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#98CBFF" />
        <stop offset={1} stopColor="#98CBFF" stopOpacity={0} />
      </linearGradient>
    </defs>
  </svg>
);
export default SvgEmptyBox;
